import { render, staticRenderFns } from "./el-checkbox.vue?vue&type=template&id=54d50916"
import script from "./el-checkbox.vue?vue&type=script&lang=js"
export * from "./el-checkbox.vue?vue&type=script&lang=js"
import style0 from "./el-checkbox.vue?vue&type=style&index=0&id=54d50916&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports